module.exports = __webpack_public_path__ + "img/photo_andre.65893bf1.png";